import { __assign, __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from 'inversify';
import NeoTypes from '../AppServices/NeoTypes';
var MenuItemProvider = /** @class */ (function () {
    function MenuItemProvider(routeSecurityService) {
        this.routeSecurityService = routeSecurityService;
    }
    /**
     * Processes a list of routes into a list of menu items for display in a menu component.
     * @param routeItems List of items from the route provider.
     * @param defaults Defaults to apply to menu items.
     */
    MenuItemProvider.prototype.processRoutes = function (routeItems, defaults) {
        if (defaults === void 0) { defaults = { hideWhenEmpty: true, collapseSingle: true }; }
        var filtered = [];
        for (var _i = 0, routeItems_1 = routeItems; _i < routeItems_1.length; _i++) {
            var route = routeItems_1[_i];
            var menuItem = __assign(__assign({}, defaults), route);
            var canShow = this.canShowItem(menuItem);
            if (canShow) {
                if (menuItem.children) {
                    menuItem.children = this.processRoutes(menuItem.children);
                    if (!menuItem.path) {
                        if (menuItem.children.length === 0 && menuItem.hideWhenEmpty !== false) {
                            // Hide empty nodes with no path of their own
                            canShow = false;
                        }
                        else if (menuItem.children.length == 1 && menuItem.collapseSingle !== false) {
                            // Merge single node into parent if parent has no path of it's own.
                            menuItem = menuItem.children[0];
                        }
                    }
                }
            }
            if (canShow) {
                filtered.push(menuItem);
            }
        }
        return filtered;
    };
    /**
     * Returns true if the menu item can be shown. Does not check children.
     */
    MenuItemProvider.prototype.canShowItem = function (menuItem) {
        return this.routeSecurityService.menuItemAllowed(menuItem);
    };
    MenuItemProvider = __decorate([
        injectable(),
        __param(0, inject(NeoTypes.Routing.RouteSecurityService.symbol)),
        __metadata("design:paramtypes", [Object])
    ], MenuItemProvider);
    return MenuItemProvider;
}());
export { MenuItemProvider };
